define(['../validation', '../../util/is-undefined-or-null.js'], function(validation, isUndefinedOrNull) {
    'use strict';
    validation.addCustomValidationRule('range', function(val, options) {
        return (!options.hasOwnProperty('min') || isUndefinedOrNull(options.min) || val >= options.min) &&
            (!options.hasOwnProperty('max') || isUndefinedOrNull(options.max) || val <= options.max);
    });
});